export enum NotificationType {
    System = 1,
    User = 2,
}

